import React from 'react';
import { Trans } from 'react-i18next';
import { ErrorMessageProps } from './ErrorMessage.types';
import Styled from './ErrorMessage.styled';


export default function ErrorMessage({ errorText, dataTestId }: ErrorMessageProps) {
    const [key, value] = errorText.split('|');
    const minLength = value;

    return (
        <Styled.ErrorMessageWrapper data-test-id={`${dataTestId}-error-message`}>
            <Styled.ErrorMessageText>
                <Trans
                    i18nKey={key}
                    ns="login"
                    values={{ minLength }}
                />
            </Styled.ErrorMessageText>
        </Styled.ErrorMessageWrapper>
    );
}
